import { Component, OnDestroy, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { TokenService } from '../../../@core/services/token.service';
import { SettingsService } from '../../../../../src/app/settings/settings.service';
import { CdTimerComponent } from 'angular-cd-timer';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  
  @ViewChild('basicTimer', { static: true }) basicTimer: CdTimerComponent; 
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  breakTime;
  breakTime2;
  timerShow = false;
  showKioskForCompanyRole = '';
  user: any;
  authData;
  
  displayMaximizable2: boolean  = false;
  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [
    { title: 'Profile' },
    { title: 'Log out', link: '/auth/login' },
  ];

  constructor(private sidebarService: NbSidebarService,
              private menuService: NbMenuService,
              private themeService: NbThemeService,
              private userService: UserData,
              private layoutService: LayoutService,
              private router: Router,
              private settingsService: SettingsService,
              private breakpointService: NbMediaBreakpointsService,
              private tokenService: TokenService,
              private cdr: ChangeDetectorRef,
              
              ) {
                      
            let token = this.tokenService.getToken();
            this.authData = this.tokenService.getToken();
            this.user =  this.authData.user.name;
              if(this.authData.user.role != null){

                console.log("authData =>", this.authData.user.name);
                console.log("role name =>", this.authData.user.role.role.name);
                this.showKioskForCompanyRole = this.authData.user.role.role.name;
              }
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    // if(this.authData.user.role == null){

    //   this.userService.getUsers()
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((users: any) => this.user = users.nick);
    //   }

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

      this.settingsService.showBreakTimer.subscribe(
        (duration)=>{
          console.log(typeof duration, duration);
          this.breakTime = duration;
          this.timerShow = true;
          // this.basicTimer.reset();
          this.basicTimer.start();
          this.breakTime = duration;
          this.basicTimer.countdown = true;
          // this.cdr.detectChanges();
        }
      );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }



  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  gotoKiosk() {
    this.router.navigate(["./kiosk"]);
  }

  gotoEmployeeKiosk() {
    this.router.navigate(["./employee-kiosk"]);
  }

  notifyPeoples(){
    this.displayMaximizable2 = true;
  
  }

  gotoSelfServicePortal(){
    this.router.navigate(["/selfServicePortal"]);
  }


}
